import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { ArrowRight, Calendar, FileText } from 'lucide-react';

export default function CTASection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation<HTMLElement>({ threshold: 0.3 });

  return (
    <section
      ref={sectionRef}
      className="relative bg-[#05060B] py-20 lg:py-24 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(6,182,212,0.15)_0%,transparent_60%)] pointer-events-none" />

      <div className="relative z-10 w-full px-6 lg:px-12 xl:px-20">
        <div className="max-w-4xl mx-auto text-center">
          <div 
            className={`glass-card p-10 lg:p-14 transition-all duration-1000 ${
              isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
            }`}
          >
            <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6">
              Ready to grow your{' '}
              <span className="text-cyan-400 cyan-glow">Amazon business?</span>
            </h2>
            <p className="text-lg text-dark-400 mb-8 max-w-2xl mx-auto">
              Book a free strategy call. We'll review your account, identify opportunities, and show you exactly how we can help.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="#contact" className="btn-primary inline-flex items-center justify-center gap-2 group text-base px-8 py-4">
                <Calendar className="w-5 h-5" />
                Book Strategy Call
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
              <a href="#reporting" className="btn-secondary inline-flex items-center justify-center gap-2 text-base px-8 py-4">
                <FileText className="w-5 h-5" />
                See Sample Report
              </a>
            </div>

            <p className="text-sm text-dark-500 mt-6">
              No commitment required. 30-minute call. Actionable insights guaranteed.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
